
export { pmtAdUnits } from "./pmtAdsense.contants"